import React, { ReactNode } from "react"

import { CardType } from "../types"
import { ReactComponent as BankFallbackCard } from "./images/bank-fallback-card.svg"
import { ReactComponent as CharityFallbackCard } from "./images/charity-fallback-card.svg"
import { ReactComponent as PaypalFallbackCard } from "./images/paypal-fallback-card.svg"
import { ReactComponent as VenmoFallbackCard } from "./images/venmo-fallback-card.svg"
import { ReactComponent as VisaFallbackCard } from "./images/visa-fallback-card.svg"

export const FALLBACK_CATEGORIES_MAP: Record<CardType, ReactNode> = {
  [CardType.BANK]: <BankFallbackCard />,
  [CardType.CHARITIES]: <CharityFallbackCard />,
  [CardType.PAYPAL]: <PaypalFallbackCard />,
  [CardType.VISA]: <VisaFallbackCard />,
  [CardType.VENMO]: <VenmoFallbackCard />,
  [CardType.MERCHANT_CARDS]: "Merchant",
  [CardType.INSTANT_DEBIT_TRANSFERS]: (
    <img
      src="https://www.datocms-assets.com/85985/1734452100-instant-debit-transfers.svg"
      alt="Instant Debit Transfer"
      width="50px"
      height="30px"
    />
  ),
}
